import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchNextShifts = () => apiActionCreator({
  'endpoint': '/pickingProcesses/nextShifts',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_NEXT_SHIFTS,
    ActionTypes.FETCHED_NEXT_SHIFTS,
    [
      ActionTypes.FETCHED_NEXT_SHIFTS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPickingIndicators = () => apiActionCreator({
  'endpoint': '/pickingProcesses/indicators',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PICKING_INDICATORS,
    ActionTypes.FETCHED_PICKING_INDICATORS,
    [
      ActionTypes.FETCHED_PICKING_INDICATORS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const showMessageWhenThereIsNotLabels = (response) => {
  if (response.count && response.count > 0) {
    return {
      'type': ActionTypes.EMPTY_PICKING_LABELS,
    };
  }
  return MessageActions.addMessageBoxInfo('No hay pedidos para atender');
};

export const printPickingLabels = (orderCode, quantityLabelsToCut, printOnlyCasabasa) => apiActionCreator({
  'endpoint': `/pickingProcesses/orderTypes/${orderCode}/labels?onlyCasabaca=${printOnlyCasabasa}`,
  'authenticated': true,
  'types': [
    ActionTypes.PRINTING_PICKING_LABELS,
    [
      {
        'type': ActionTypes.PRINTED_PICKING_LABELS,
        'payload': {orderCode, quantityLabelsToCut},
      },
      (response) => showMessageWhenThereIsNotLabels(response),
    ],
    [
      ActionTypes.PRINTED_PICKING_LABELS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const reprintPickingLabels = (printCode, labelsBlockSize, parametersObject = {}) => apiActionCreator({
  'endpoint': `/pickingProcesses/labels/${printCode}${getUrlParameters(parametersObject)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_LABELS_TO_REPRINT,
    {
      'type': ActionTypes.GOT_LABELS_TO_REPRINT,
      'payload': labelsBlockSize,
    },
    [
      ActionTypes.GOT_LABELS_TO_REPRINT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deleteAllPickingLabels = () => ({
  'type': ActionTypes.DELETE_ALL_PICKING_LABELS,
});

export const deletePickingLabelsByOrderCode = (orderCode) => ({
  'type': ActionTypes.DELETE_PICKING_LABELS_BY_ORDER_CODE,
  'payload': orderCode,
});

export const clearShiftsData = () => ({
  'type': ActionTypes.CLEAR_SHIFTS_DATA,
});
